import {Feature} from 'acng/core/model/feature.js';

const name = 'amateurPool';
export default name;
export const amateurPoolFeature = new Feature(name);
